import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const Contact = () => {
  return (
    <div className="bg-black min-h-screen pt-32 pb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-testid="contact-title">
            Nous <span className="text-red-600">Contacter</span>
          </h1>
          <p className="text-gray-400 text-lg mb-12">
            Une question ? Une commande spéciale ? N'hésitez pas à nous contacter !
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Téléphone */}
            <a href="tel:0767682464" className="group">
              <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 hover:border-red-600/50 rounded-xl p-8 transition-all duration-300 h-full" data-testid="contact-phone-card">
                <div className="bg-red-600/20 p-4 rounded-xl w-fit mb-6 group-hover:bg-red-600/30 transition-colors">
                  <Phone className="text-red-500" size={32} />
                </div>
                <h2 className="text-2xl font-bold text-white mb-2">Téléphone</h2>
                <p className="text-gray-400 mb-4">Appelez-nous pour commander ou pour toute question</p>
                <p className="text-red-400 text-2xl font-bold">{restaurantInfo.phone}</p>
              </div>
            </a>

            {/* Email */}
            <a href="mailto:seven.pizza13005@gmail.com" className="group">
              <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 hover:border-red-600/50 rounded-xl p-8 transition-all duration-300 h-full" data-testid="contact-email-card">
                <div className="bg-red-600/20 p-4 rounded-xl w-fit mb-6 group-hover:bg-red-600/30 transition-colors">
                  <Mail className="text-red-500" size={32} />
                </div>
                <h2 className="text-2xl font-bold text-white mb-2">Email</h2>
                <p className="text-gray-400 mb-4">Envoyez-nous un email pour toute demande</p>
                <p className="text-red-400 text-xl font-bold">seven.pizza13005@gmail.com</p>
              </div>
            </a>

            {/* Adresse */}
            <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-xl p-8" data-testid="contact-address-card">
              <div className="bg-red-600/20 p-4 rounded-xl w-fit mb-6">
                <MapPin className="text-red-500" size={32} />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Adresse</h2>
              <p className="text-gray-400 mb-4">Venez nous rendre visite</p>
              <p className="text-white text-lg font-semibold">{restaurantInfo.address}</p>
            </div>

            {/* Horaires */}
            <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-xl p-8" data-testid="contact-hours-card">
              <div className="bg-red-600/20 p-4 rounded-xl w-fit mb-6">
                <Clock className="text-red-500" size={32} />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Horaires</h2>
              <p className="text-gray-400 mb-4">Ouvert {restaurantInfo.hours.days}</p>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-400">Midi</span>
                  <span className="text-white font-semibold">{restaurantInfo.hours.lunch}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Soir</span>
                  <span className="text-white font-semibold">{restaurantInfo.hours.dinner}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Map placeholder */}
          <div className="mt-12 bg-gradient-to-br from-gray-900 to-black border border-red-600/30 rounded-xl p-8 text-center">
            <h2 className="text-2xl font-bold text-white mb-4">Livraison Gratuite sur Marseille</h2>
            <div className="flex flex-wrap justify-center gap-2">
              {restaurantInfo.deliveryZones.map((zone) => (
                <span 
                  key={zone} 
                  className="bg-red-600/20 text-red-400 text-sm px-4 py-2 rounded-full border border-red-500/30 font-semibold"
                >
                  {zone}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
